import type { HTMLAttributes } from "react";
import {
  categoryLabels,
  categoryTokens,
  type WellbeingCategory,
} from "@andrum/design-tokens";
import { cn } from "../lib/cn";

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  category?: WellbeingCategory;
  tone?: "neutral" | "primary" | "secondary";
};

export function Badge({
  className,
  category,
  tone = "neutral",
  children,
  ...props
}: BadgeProps) {
  if (category) {
    const tokens = categoryTokens[category];
    return (
      <span
        className={cn(
          "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
          className
        )}
        style={{
          color: tokens.foreground,
          backgroundColor: tokens.background,
        }}
        {...props}
      >
        {children ?? categoryLabels[category]}
      </span>
    );
  }

  const toneClass =
    tone === "primary"
      ? "bg-primary-soft text-primary"
      : tone === "secondary"
        ? "bg-secondary-soft text-secondary"
        : "bg-surface-muted text-foreground-muted";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
        toneClass,
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
